export default __webpack_public_path__ + "media/images/error-graphic-3e339bcb.svg";